// Small helper used by the Cutting Simulator to print arbitrary HTML
// (e.g. report tables, PDF previews) through a sandboxed iframe so the
// current page's styles / state are not disturbed.
export function safePrintHTML(html) {
  try {
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    document.body.appendChild(iframe);
    const doc = iframe.contentWindow?.document;
    if (!doc) return false;
    doc.open();
    doc.write(html);
    doc.close();
    // Give the browser a tick to layout, then print.
    setTimeout(() => {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (e) {
        // noop
      }
      setTimeout(() => {
        try { document.body.removeChild(iframe); } catch (e) { /* noop */ }
      }, 1000);
    }, 200);
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("safePrintHTML failed:", e);
    return false;
  }
}
